import { useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

const useBreakPoints = () => {
  const theme = useTheme();
  
  // Standard breakpoints
  const xs = useMediaQuery(theme.breakpoints.up('xs'));
  const sm = useMediaQuery(theme.breakpoints.up('sm'));
  const md = useMediaQuery(theme.breakpoints.up('md'));
  const lg = useMediaQuery(theme.breakpoints.up('lg'));
  const xl = useMediaQuery(theme.breakpoints.up('xl'));
  
  // Custom breakpoints
  const xll = useMediaQuery(theme.breakpoints.up('xll'));
  const xlll = useMediaQuery(theme.breakpoints.up('xlll'));
  const xl4 = useMediaQuery(theme.breakpoints.up('xl4'));

  const getAdjustedValues = (value) => {
    return xl4 ? value * 2.46 : xlll ? value * 1.66 : xll ? value * 1.25 : value;
  };

  // Additional utility functions
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return { 
    getAdjustedValues,
    isMobile,
    isTablet,
    isDesktop,
    breakpoints: {
      xs, sm, md, lg, xl, xll, xlll, xl4
    }
  };
};

export default useBreakPoints;